import { useFlowStore } from '@dashboard/modules/flow/stores/flowStore'
import type { FunnelDefinitionNode, FunnelDefinitionRootNode } from '../builder/types/nodes'

type ConfigRootNode = {
  type: 'root'
  _uuid?: string
  child?: FunnelDefinitionNode[]
}
type TraversableNode = FunnelDefinitionNode | FunnelDefinitionRootNode | ConfigRootNode
type NodeCallback = (node: TraversableNode, nuke: () => void) => void

const funnelDefinitionEachRun = (nodeRun: FunnelDefinitionNode[], callback: NodeCallback) => {
  for (let index = nodeRun.length - 1; index >= 0; index--) {
    const node = nodeRun[index]
    if (node === undefined) {
      throw new Error('Missing node in funnel definition run')
    }
    funnelDefinitionEach(node, callback, () => {
      nodeRun.splice(index, 1)
    })
  }
}

export const funnelDefinitionEach = (node: TraversableNode, visitNode: NodeCallback, nuke: () => void = () => {}) => {
  let nuked = false
  visitNode(node, () => {
    nuke()
    nuked = true
  })

  if (nuked) {
    return
  }

  if (node.type === 'root') {
    funnelDefinitionEachRun(node.child || [], visitNode)
    return
  }

  if (node.type === 'sg' || node.type === 'random' || node.type === 'highscore') {
    if (node.split) {
      node.split.forEach((split) => funnelDefinitionEachRun(split.child, visitNode))
    }
    return
  }

  if (node.type === 'yesno') {
    funnelDefinitionEachRun(node.yes, visitNode)
    funnelDefinitionEachRun(node.no, visitNode)
  }
}

export const funnelDefinitionForEachFlow = (callback: NodeCallback) => {
  const flowStore = useFlowStore()
  flowStore.flows.forEach((flow) => {
    funnelDefinitionEach(flow.funnelDefinition as FunnelDefinitionRootNode, callback)
  })
}
